import defineComponent from 'flight';
import JST from 'static/script/templates/templates';

function DataListUI() {

    this.defaultAttrs({
        activeSelector: 'li.active',
        activeClass: 'active'
    });

    this._getTemplate = function (items) {
        return JST['templates/datalist.html']({items: items});
    };

    this._run = function (evt) {
        if (evt.which === 38 || evt.which === 40) {
            return;
        }

        let value = this.$node.val();
        let hits = _.filter(this._values, function (item) {
            return item.indexOf(value) === 0;
        });

        if (this._$tpl) {
            this._$tpl.remove();
        }

        this._render(hits);
    };

    this._render = function (hits) {
        if (hits.length > 0) {
            this._$tpl = $(this._getTemplate(hits));
            this._attachEvent();
            this._setPosition();
            $('body').append(this._$tpl);
        }
    };

    //jshint maxcomplexity: 7
    this._attachEvent = function () {
        this._$tpl.on('mousedown enterdown', 'button', function (evt) {
            this.$node.val($(evt.target).text());
            this.$node.blur();
            this._triggerGA(evt.type);
        }.bind(this));
    };

    this._triggerGA = function (evtType) {
        this.trigger(document, 'analytics:track-event', {
            category: 'Advanced search',
            action: 'Datalist value change',
            label: 'Change by ' + evtType,
            userTriggered: true
        });
    };

    this._setPosition = function () {
        let left,
            top,
            width;

        left = parseInt(this.$node.offset().left, 10);
        top = parseInt(this.$node.offset().top + this.$node.outerHeight(), 10);
        width = parseInt(this.$node.outerWidth(), 10);

        this._$tpl.css('top', top);
        this._$tpl.css('left', left);
        this._$tpl.css('width', width);
    };

    this._lostFocus = function () {
        if (this._$tpl) {
            window.setTimeout(function () {
                this._$tpl.remove();
            }.bind(this), 100);
        }
    };

    this._init = function () {
        let values = this.$node.data('datalist');
        this._values = values.split('|');
        this._$tpl = $(this._getTemplate(this._values));
    };

    this._keyDown = function (evt) {
        if (evt.which === 38 || evt.which === 40 || evt.which === 13) {
            evt.preventDefault();
            if (evt.which === 38) {
                this._goUp();
            } else if (evt.which === 40) {
                this._goDown();
            } else {
                // Enter
                if (this._$tpl.find(this.attr.activeSelector + ':eq(0)').length > 0) {
                    evt.preventDefault();
                    this._$tpl.find(this.attr.activeSelector + ':eq(0) button').trigger('enterdown');
                }
            }
        }
    };

    this._goUp = function () {
        let currentIndex = this._$tpl.find(this.attr.activeSelector + ':eq(0)').index(),
            newIndex = currentIndex - 1;

        if (newIndex < 0) {
            newIndex = 0;
        }

        this._flagChecked(newIndex);
    };

    this._goDown = function () {
        let currentIndex = this._$tpl.find(this.attr.activeSelector + ':eq(0)').index(),
            newIndex = currentIndex + 1,
            maxIndex = this._$tpl.find('li').length - 1;

        if (newIndex > maxIndex) {
            newIndex = maxIndex;
        }

        this._flagChecked(newIndex);
    };

    this._flagChecked = function (index) {
        this._$tpl.find(this.attr.activeSelector).removeClass(this.attr.activeClass);
        this._$tpl.find('li:eq(' + index +')').addClass(this.attr.activeClass);
    };

    this.after('initialize', function() {
        this._init();
        this.on('keydown', this._keyDown);
        this.on('keyup focusin', this._run);
        this.on('blur', this._lostFocus);
        this.on(document, 'utils:window-resize:resized', this._setPosition);
    });
}

module.exports = defineComponent.component(DataListUI);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/datalist-ui.js